export class ChatOption {
  action: string;
  display: string;

  constructor(action: string, display: string) {
    this.action = action;
    this.display = display;
  }

  static generalAssistantOptions(): { option: ChatOption, emoji: string }[] {
      return [
        { option: new ChatOption("logData", "Log data"), emoji: '✍🏽'}, 
        { option: new ChatOption("analyseMyHealth", "Analyse my health"), emoji: '📈'}, 
        { option: new ChatOption("showIvy", "Get IVY info"), emoji: '🌸'}, 
        { option: new ChatOption("learn", "Learn about"), emoji: '💡'}, 
        { option: new ChatOption("chat", "Chat"), emoji: '💛'}, 
        { option: new ChatOption("uploadDocument", "Upload document"), emoji: '📎'}, 
        { option: new ChatOption("setReminder", "Set a reminder"), emoji: '⏰'}, 
        { option: new ChatOption("getRecommendations", "Get recommendations"), emoji: '🍎'}, 
      ]
  }
}